import { withStyles } from '@material-ui/core';

import SubtitleBlock from './component';
import styles from './styles';

export default withStyles(styles)(SubtitleBlock);
